import { Children, ReactElement } from 'react';

export default (children: ReactElement[], slot: string): ReactElement[] => (
  Children.toArray(children).filter(({ props }) => props.slot === slot)
);
